Vendd.Scripts.load(function () {
    var $wrapper = $('.x-brand-widget');

    if ($wrapper.length < 1)
        return;

    
    //On click Brands Button
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        if ($(this).hasClass('x-open')) {
            $('html').removeClass('hide-sticky-btns');
            $('.js-widget-trigger', $wrapper).removeClass('x-open');
            $('.js-widget-container', $wrapper).removeClass('x-expanded');
        } else {
            $('html').addClass('hide-sticky-btns');
            $('.js-widget-trigger', $wrapper).addClass('x-open');
            $('.js-widget-container', $wrapper).addClass('x-expanded');

            //init height calculation
            if ($(window).outerWidth() < 960 && isTouch()) {                
                calculateHeight();
            }     
            
            //init Plugin for Search
            initSearch();

        }
    });

    //Calculate height on resize
    $(window).resize(function () {
        if ($(window).outerWidth() < 960 && isTouch()) {
            if ($('.js-widget-container', $wrapper).hasClass('x-expanded')) {
                calculateHeight();
            }
        }
    });

    //On click outside Brand Widget
    $(document).on('click', function (e) {

        if (!$('.js-widget-trigger', $wrapper).hasClass('x-open'))
            return;

        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.js-widget-trigger', $wrapper).removeClass('x-open');
            $('.js-widget-container', $wrapper).removeClass('x-expanded');
        }
    });

    function calculateHeight() {
        var $container = $('.js-widget-container', $wrapper);
        var $windowHeight = $(window).height();
        var $headerHeight = $('.header-region').height();
        var $criticalHeight = $windowHeight - $headerHeight;

        $container.css('height', $criticalHeight);

    }

    function initSearch() {

        var options = {
            valueNames: ['brand']
        };

        var brandList = new List('brand-search', options);

        brandList.on('updated', function (list) {
            if (list.matchingItems.length > 0) {
                $('.no-result').hide();
            } else {
                $('.no-result').show();
            }
        });
    }

});

